import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Grid from "@mui/material/Grid";

import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import WorkspaceService from "../../../../service/workspace";
import Switch from "../../../Common/Switch";
import { setPrevState } from "../../../../util/common";
import BrowseInput from "../../../Common/BrowseInputForUnload";

const UnloadForm = ({ unloadState, setUnloadState }) => {
  const { unloadPath, location, unloadEnabled } = unloadState;

  const [locationList, setLocationList] = useState([]);
  const { Workspace_id } = useParams();

  useEffect(() => {
    //Get Location List for "Location" Dropdown
    const getLocationList = async () => {
      const wsService = new WorkspaceService();
      const locationList = await wsService.getLocationList(Workspace_id);
      const filteredResult = locationList.filter(
        (item) =>
          !["salesforce", "sftp", "sharepoint", "mysql", "veevavault", "snowflake"].includes(
            item.Detail.type.toLowerCase()
          )
      );

      setLocationList(filteredResult);
    };

    getLocationList();
  }, [Workspace_id]);

  const handleToggleUnload = () => {
    setPrevState(setUnloadState, {
      unloadEnabled: !unloadEnabled,
      unloadPath: unloadEnabled ? "" : unloadPath,
      location: unloadEnabled ? "" : location,
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <FormControl className="switch" sx={{ marginTop: "10px" }} component="fieldset">
          <FormGroup aria-label="position" row>
            <FormControlLabel
              value={unloadEnabled}
              control={<Switch />}
              label="Enable Error Report"
              labelPlacement="start"
              sx={{ margin: "0" }}
              onChange={handleToggleUnload}
              checked={unloadEnabled ? true : false}
            />
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
          md: 4,
        }}
      >
        <FormControl disabled={!unloadEnabled} fullWidth variant="outlined">
          <InputLabel>Connection</InputLabel>
          <Select
            required
            value={location}
            onChange={(e) => setPrevState(setUnloadState, { location: e.target.value })}
            label="Connection"
            MenuProps={{ sx: { height: "220px" } }}
          >
            {locationList.map((option) => (
              <MenuItem key={option.Stage_id} value={option.Stage_id}>
                {option.Name}
                {option?.IsDataLake === 1 &&
                  (option?.Detail.type.toLowerCase() === "s3" ? (
                    <img src="/images/aws-s3-logo.png" alt="S3" style={{ width: "20px", marginLeft: "10px" }} />
                  ) : (
                    <img src="/images/azure-logo.png" alt="Azure" style={{ width: "20px", marginLeft: "10px" }} />
                  ))}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 8,
          md: 8,
        }}
      >
        <BrowseInput
          disabled={!unloadEnabled}
          connections={locationList}
          connection={location}
          path={unloadPath}
          setPath={(path) => setPrevState(setUnloadState, { unloadPath: path })}
        />
      </Grid>
    </Grid>
  );
};

export default UnloadForm;
